import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ald-request-header',
  templateUrl: './ald-request-header.component.html',
  styleUrls: ['./ald-request-header.component.css']
})
export class ALDRequestHeaderComponent implements OnInit {
  @Input() CompanyName: string;
  @Input() CompanyCR: string; 
  @Input() ATOCertificate: string;
  @Input() RequestFriendlyName: string;
  @Input() RequestSubmissionDate: Date;
  @Input() RequestStatus: string;
  @Input() comment: string;
  @Input() AirOperatorCertificate: string
  //  @Input() IsReasonRequired: boolean = true;


  constructor() { 
  }

  ngOnInit() {
  }

}
